import CancelIcon from "@mui/icons-material/Cancel"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"
import HelpOutlineIcon from "@mui/icons-material/HelpOutline"
import { ResultType } from "graphql/types"

type ResultIconProps = {
  result: ResultType
  size?: number
}

export const ResultIcon = ({ result, size = 18 }: ResultIconProps) => {
  switch (result) {
    case ResultType.PASSED:
      return <CheckCircleIcon sx={{ color: "green", fontSize: size }} />
    case ResultType.FAILED:
      return <CancelIcon sx={{ color: "red", fontSize: size }} />
    case ResultType.NOT_EVALUATED:
      return <HelpOutlineIcon sx={{ color: "orange", fontSize: size }} />
    default:
      return <HelpOutlineIcon sx={{ color: "orange", fontSize: size }} />
  }
}
